import { render, staticRenderFns } from "./AssistRequestContent.vue?vue&type=template&id=126958bc&scoped=true"
import script from "./AssistRequestContent.vue?vue&type=script&lang=ts"
export * from "./AssistRequestContent.vue?vue&type=script&lang=ts"
import style0 from "./AssistRequestContent.vue?vue&type=style&index=0&id=126958bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126958bc",
  null
  
)

export default component.exports